export default __webpack_public_path__ + "static/media/PalmasClosed.d23f5a10.jpg";